import { jsx as _jsx } from "react/jsx-runtime";
import { WarningAlt, Time, WifiOff, WarningFilled, UserMultiple, Error } from '@core/icons-react';
import { StateCard } from '@core/ui';
export const ERROR_MESSAGES = {
    invalid_link: {
        icon: WarningAlt,
        iconVariant: 'warning',
        title: 'Invalid Link',
        message: 'The link you used is invalid or has expired. Please request a new one.',
        actionText: 'Request New Link'
    },
    session_expired: {
        icon: Time,
        iconVariant: 'warning',
        title: 'Session Expired',
        message: 'Your session has expired. Please sign in again to continue.',
        actionText: 'Sign In'
    },
    network: {
        icon: WifiOff,
        iconVariant: 'error',
        title: 'Network Error',
        message: 'Unable to connect to our servers. Please check your internet connection and try again.',
        actionText: 'Try Again'
    },
    rate_limit: {
        icon: WarningFilled,
        iconVariant: 'warning',
        title: 'Too Many Attempts',
        message: 'You\'ve made too many attempts. Please wait a moment before trying again.',
        actionText: 'Try Again'
    },
    rate_limit_with_delay: {
        icon: WarningFilled,
        iconVariant: 'warning',
        title: 'Too Many Attempts',
        message: 'You\'ve made too many attempts. Please wait {minutes} minutes before trying again.',
        actionText: 'Try Again'
    },
    account_locked: {
        icon: Error,
        iconVariant: 'error',
        title: 'Account Locked',
        message: 'Your account has been locked for security reasons. Please contact support for assistance.',
        actionText: 'Contact Support'
    },
    permission_denied: {
        icon: UserMultiple,
        iconVariant: 'error',
        title: 'Access Denied',
        message: 'You don\'t have permission to access this resource.',
        actionText: 'Go Back'
    },
    generic: {
        icon: WarningFilled,
        iconVariant: 'error',
        title: 'Something Went Wrong',
        message: 'An unexpected error occurred. Please try again later.',
        actionText: 'Try Again'
    }
};
export function ErrorDisplay({ type = 'generic', customMessage, retryAfter, onAction, variant = 'ghost' }) {
    const baseMessage = ERROR_MESSAGES[type];
    const message = { ...baseMessage, ...customMessage };
    // If retryAfter is provided and it's a rate limit error, calculate minutes
    let displayMessage = message.message;
    if (type === 'rate_limit_with_delay' && retryAfter) {
        const minutes = Math.ceil(retryAfter / 60);
        displayMessage = message.message.replace('{minutes}', minutes.toString());
    }
    const handleAction = () => {
        if (onAction) {
            onAction();
        }
        else {
            // Default actions based on error type
            switch (type) {
                case 'session_expired':
                case 'invalid_link':
                    // Navigate to login
                    window.location.href = '/login';
                    break;
                case 'network':
                case 'generic':
                case 'rate_limit':
                    // Reload the page
                    window.location.reload();
                    break;
                case 'account_locked':
                    // Open support page
                    window.open('/support', '_blank');
                    break;
                case 'permission_denied':
                    // Go back
                    window.history.back();
                    break;
            }
        }
    };
    return (_jsx("div", { style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '400px',
            padding: '2rem'
        }, children: _jsx(StateCard, { variant: variant, width: 480, icon: message.icon, iconVariant: message.iconVariant, title: message.title, subtitle: displayMessage, buttonText: message.actionText, onButtonClick: handleAction }) }));
}
export default ErrorDisplay;
